<template>
    <kubernetes-common-panel
            v-model="value"
            :img="img"
            :readOnly="readOnly"
            @openDesDoc="desDocOpen"
            @close="closePanel"
    >
        <template slot="headline">
            <v-tabs
                    v-model="activeTab"
                    v-if="value.status">
                <v-tab
                        v-for="(tab, idx) in tabItems"
                        :key="idx">
                    <v-list-item-title>{{ tab }}</v-list-item-title>
                </v-tab>
            </v-tabs>
            <v-list-item-title 
                    v-else
                    class="headline">
                {{ value._type }}
            </v-list-item-title>
        </template>

        <template slot="descriptionText">
            <span>{{ descriptionText }}</span>
        </template>

        <template slot="edit-layout">
            <v-layout v-if="value.status && activeTab == 0" wrap>
                <v-flex>
                    <v-card flat>
                        <v-card-text>
                            <tree-view
                                    :data="status"
                                    :options="{
                                            rootObjectKey: 'status'
                                        }"
                            ></tree-view>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout v-else wrap>
                <v-flex shrink style="width: 180px;">
                    <v-card flat>
                        <v-card-text>
                            <v-text-field                                
                                    label="Name"
                                    v-model="value.object.metadata.name"
                                    autofocus
                                    :disabled="readOnly"
                            ></v-text-field>
                            <v-text-field
                                    label="Image"
                                    :disabled="readOnly"
                                    v-model="value.object.spec.template.spec.containers[0].image"
                            ></v-text-field>
                            <v-select                                
                                    label="restart Policy"
                                    :disabled="readOnly"
                                    v-model="value.object.spec.template.spec.restartPolicy"
                                    :items="restartPolicyList">
                            </v-select>
                            <kube-number-field
                                    :desDoc="'#pod-backoff-failure-policy'"
                                    :readOnly="readOnly"
                                    @openDesDoc="desDocOpen"
                                    :label="'backoffLimit'"
                                    v-model="value.object.spec.backoffLimit"
                            ></kube-number-field>
                            <kube-attr-field 
                                    v-model="value" 
                                    :readOnly="readOnly"
                            ></kube-attr-field>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex>
                    <kube-yaml-editor
                            v-model="value.object"
                            :readOnly="readOnly"
                    ></kube-yaml-editor>
                </v-flex>
            </v-layout>
        </template>
    </kubernetes-common-panel>

</template>


<script>
    import KubernetesPanel from "../KubernetesPanel";

    export default {
        mixins: [KubernetesPanel],
        name: 'job-property-panel',
        computed: {
            descriptionText() {
                return 'Job'
            },
            status() {
                return JSON.parse(JSON.stringify(this.value.status))
            },
        },
        data: function () {
            return {
                restartPolicyList: [ 'Always', 'OnFailure', 'Never' ],
                activeTab: 0,
                tabItems: [ "status", "property" ],
            }
        },
        watch: {
            status: {
                deep: true,
                handler: function () {
                }
            },
        },
        methods: {
            desDocOpen(property) {
                var url = 'https://kubernetes.io/docs/concepts/workloads/controllers/job/'
                if(property) {
                    url += property
                }
                window.open(url)
            },
        }
    }
</script>


<style lang="scss" rel="stylesheet/scss">
    .v-icon.outlined {
        border: 1px solid currentColor;
        border-radius: 0%;
    }

    .md-sidenav .md-sidenav-content {
        width: 400px;
    }

    .md-sidenav.md-right .md-sidenav-content {
        width: 600px;
    }

    .flip-list-move {
        transition: transform 0.5s;
    }

    .no-move {
        transition: transform 0s;
    }

    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }

    .list-group {
        min-height: 20px;
    }

    .list-group-item {
        cursor: move;
    }

    .list-group-item i {
        cursor: pointer;
    }
</style>
